// extracted by mini-css-extract-plugin
export default {"initialsBadge":"InitialsBadge_initialsBadge__r5bn1"};